<div class="sidebar">
  <div class="logo-section" style="text-align: center;">
    <img src="/assets/sidelogo.png" alt="Company Logo" style="max-width: 80%; height: auto; border-radius: 10px;" />
  </div>
  <div style="text-align: center; margin-bottom: 10px;">
    <img src="/assets/male.png" alt="Welcome Icon" style="max-width: 80px; height: auto;" />
    <span style="display: block; margin-top: 10px; font-size: 18px; font-weight: bold;">Welcome :
      {{user?.username}}</span>
  </div>
  <ul class="menu">
    <li><a routerLink="/home" routerLinkActive="active"> <i class="fa fa-home"></i> Dashboard</a></li>
    <li><a routerLink="/report" routerLinkActive="active"> <i class="fa fa-file"></i> Reports</a></li>
    <li><a style="cursor:pointer" (click)="openAddForm(addChangePasswordModal);this.changePasswordForm.reset();"> <i class="fa fa-key"></i> Change
        Password</a></li>
    <li> <a style="cursor:pointer" (click)="openAddForm(openLogOutModel)"> <i class="fa fa-sign-out"></i> Logout</a>
    </li>
  </ul>
  <ng-template #addChangePasswordModal let-modal>
    <div class="modal-dialog">
      <div class="modal-content change-password-container">
        <div class="modal-header">
          <h5 class="modal-title">Change Password</h5>
          <button type="button" class="btn-close" (click)="onCancel1()"></button>
        </div>
        <div class="modal-body" style="padding: 20px;">
          <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" class="form-container">

            <div class="form-group row">
              <label for="oldPassword" class="form-label">Current Password <span class="text-danger">*</span></label>
              <input [type]="showNewPassword ? 'text' : 'password'" type="password" id="oldPassword"
                formControlName="oldPassword" placeholder="Current Password" required (keydown)="preventSpace($event)"
                class="form-input">
              <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"
                (click)="showNewPassword = !showNewPassword"
                style="position: relative;
                right: 2em;
                top: .5em;
                transform: translateY(-50%);
                cursor: pointer;
                z-index: 10;
                max-width: 0%;">
              </i>
              <div *ngIf="oldPassword?.invalid && oldPassword?.touched" class="error-message">
                <div *ngIf="oldPassword?.errors?.['required']">Current Password is required</div>
              </div>
            </div>

            <div class="form-group row">
              <label for="newPassword" class="form-label">New Password <span class="text-danger">*</span></label>
              <input [type]="newPasswordDisplay ? 'text' : 'password'" type="password" id="newPassword" formControlName="newPassword" placeholder="New Password" required
                (keydown)="preventSpace($event)" class="form-input">
              <i class="fa" [ngClass]="newPasswordDisplay ? 'fa-eye-slash' : 'fa-eye'"
                (click)="newPasswordDisplay = !newPasswordDisplay"
                style="position: relative;
                right: 2em;
                top: .5em;
                transform: translateY(-50%);
                cursor: pointer;
                z-index: 10;
                max-width: 0%;">
              </i>
              <div *ngIf="newPassword?.invalid && newPassword?.touched" class="error-message">
                <div *ngIf="newPassword?.errors?.['required']">Password is required.</div>
                <div *ngIf="newPassword?.errors?.['pattern']">Password must be at least 8 characters long, contain at
                  least one number, one uppercase letter, and one lowercase letter.</div>
                <div *ngIf="newPassword?.errors?.['sameAsOldPassword']">New Password must be different from Current
                  Password.</div>
              </div>
            </div>

            <div class="form-group row">
              <label for="confirmPassword" class="form-label">Confirm Password <span
                  class="text-danger">*</span></label>
              <input [type]="confirmPasssword ? 'text' : 'password'" type="password" id="confirmPassword" formControlName="confirmPassword"
                placeholder="Confirm Password" required (keydown)="preventSpace($event)" class="form-input">
              <i class="fa" [ngClass]="confirmPasssword ? 'fa-eye-slash' : 'fa-eye'"
                (click)="confirmPasssword = !confirmPasssword"
                style="position: relative;
                right: 2em;
                top: .5em;
                transform: translateY(-50%);
                cursor: pointer;
                z-index: 10;
                max-width: 0%;">
              </i>
              <div *ngIf="confirmPassword?.invalid && confirmPassword?.touched" class="error-message">
                <div *ngIf="confirmPassword?.errors?.['required']">Confirm Password is required.</div>
                <div *ngIf="confirmPassword?.errors?.['mustMatch']">Passwords do not match.</div>
              </div>
            </div>

            <div *ngIf="passwordErrorMessage" class="error-message">
              {{ passwordErrorMessage }}
            </div>
            <div *ngIf="successMessage" class="success-message">
              {{ successMessage }}
            </div>

            <div class="form-actions">
              <button type="button" class="btn-cancel" (click)="onCancel1()">Cancel</button>
              <button type="submit" class="btn-submit" [disabled]="changePasswordForm.invalid">Update</button>
            </div>

          </form>
        </div>
      </div>
    </div>


  </ng-template>

  <ng-template #openLogOutModel let-modal>
    <div class="modal-dialog">
      <div class="modal-content change-password-container">
        <div class="modal-header">
          <h5 class="modal-title">Confirm {{statusChangeText}}</h5>
          <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body" style="padding: 20px;height: 15vh;width:100vw; word-break:break-all;">
          <p style="margin-top: 5px;">Are you sure you want to logout ?</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="modal.dismiss('Cross click')">Cancel</button>
          <button class="btn btn-success" (click)="logout(modal)">
            Log Out
          </button>

        </div>
      </div>
      <div id="customToast" class="toast">
        <i class="fa fa-check" style=" margin-right: 5px;"></i>
        <p style="display: inline;">Logout Successfully</p>
      </div>
    </div>
  </ng-template>
</div>